import { Link } from 'react-router-dom';

export default function ServicesSection() {
  const services = [
    {
      title: 'Workers Compensation Claims',
      description: 'Expert representation for workplace injury claims throughout Ohio. We handle every aspect of your case from filing to settlement.',
      image: 'https://public.readdy.ai/ai/img_res/1e28d44f186fda1a9d8651845401fc2a.jpg',
      link: '/workers-compensation-overview',
      icon: 'ri-file-list-3-line',
    },
    {
      title: 'Workplace Injury Representation',
      description: 'Comprehensive legal support for all types of workplace injuries including industrial accidents, repetitive strain, and occupational diseases.',
      image: 'https://readdy.ai/api/search-image?query=Workplace%20safety%20equipment%20and%20injury%20prevention%20materials%20in%20industrial%20setting%2C%20professional%20safety%20gear%20and%20documentation%2C%20clean%20organized%20industrial%20workspace%20with%20safety%20focus%2C%20high%20quality%20professional%20photography%20with%20simple%20background&width=800&height=600&seq=service-workplace-injury-002&orientation=landscape',
      link: '/workplace-injury-types',
      icon: 'ri-shield-cross-line',
    },
    {
      title: 'Appeals & Denied Claims',
      description: 'Aggressive advocacy for denied workers compensation claims. We fight to overturn unfair denials and secure the benefits you deserve.',
      image: 'https://readdy.ai/api/search-image?query=Legal%20appeal%20documents%20and%20gavel%20on%20professional%20desk%2C%20justice%20and%20legal%20representation%20concept%2C%20modern%20law%20office%20setting%20with%20professional%20materials%2C%20high%20quality%20legal%20photography%20with%20clean%20simple%20background&width=800&height=600&seq=service-appeals-003&orientation=landscape',
      link: '/workers-compensation-appeals',
      icon: 'ri-scales-3-line',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            How We Help Injured Workers
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Comprehensive legal representation for workers' compensation claims throughout Northeast Ohio
          </p>
        </div>

        <div className="space-y-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300"
              style={{
                transform: `rotate(${index % 2 === 0 ? '1deg' : '-1deg'})`,
              }}
            >
              <div className="grid md:grid-cols-2 gap-0">
                <div className={`relative h-80 ${index % 2 === 0 ? 'md:order-1' : 'md:order-2'}`}>
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent"></div>
                </div>
                <div className={`p-12 flex flex-col justify-center ${index % 2 === 0 ? 'md:order-2' : 'md:order-1'}`}>
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-xl mb-6">
                    <i className={`${service.icon} text-3xl text-teal-600`}></i>
                  </div>
                  <h3 className="font-serif text-3xl font-bold text-gray-900 mb-4">
                    {service.title}
                  </h3>
                  <p className="text-base text-gray-600 mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  <Link
                    to={service.link}
                    className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors group-hover:translate-x-2 transition-transform whitespace-nowrap"
                  >
                    Learn More
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}